export default __webpack_public_path__ + "static/media/logo-fbx.16afeedd.png";